var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.BBadge,{staticClass:"doi-badge"},[_c(_setup.FontAwesomeIcon,{attrs:{"icon":_setup.faLink}}),_vm._v(" "),_c('a',{attrs:{"href":_setup.doiLink,"target":"_blank","rel":"noopener noreferrer"}},[_vm._v(_vm._s(_setup.props.doi))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }